import React, { useState } from 'react';
import { X, Link, Share2, QrCode, Activity, ChevronRight, Eye } from 'lucide-react';
import { QRCodeCanvas } from 'qrcode.react';
import { forms as NEW_FORMS } from '../data/forms';

// Test verisini çekiyoruz (App.js'dekinin aynısı)
const AVAILABLE_TESTS = NEW_FORMS.map(form => ({
  id: form.id, name: form.title, category: 'Psikolojik Değerlendirme',
  description: form.description, type: form.type, options: form.options, questions: form.items, intro: form.intro,
  reference: form.reference // 🎯 İŞTE EKSİK OLAN SİHİRLİ KÖPRÜ BURASI
}));

// --- YENİ BİLEŞEN: ŞIK ÖNİZLEME MODALI ---
const PreviewModal = ({ test, onClose }) => {
  return (
    <div className="fixed inset-0 bg-slate-900/90 backdrop-blur-sm flex items-center justify-center z-[70] p-4 md:p-6 no-print">
      <div className="bg-white rounded-3xl w-full max-w-3xl max-h-[90vh] flex flex-col relative shadow-2xl animate-in fade-in zoom-in-95 duration-200">
        
        <div className="p-6 border-b border-slate-100 flex justify-between items-center shrink-0">
          <div>
            <span className="bg-indigo-50 text-indigo-600 px-2.5 py-1 rounded-md text-[10px] font-black uppercase tracking-widest mb-2 inline-block">Önizleme Modu</span>
            <h2 className="text-xl md:text-2xl font-black text-slate-800">{test.name}</h2>
          </div>
          <button onClick={onClose} className="p-2 bg-slate-50 hover:bg-red-50 text-slate-400 hover:text-red-500 rounded-full transition-colors">
            <X className="h-6 w-6"/>
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1 bg-slate-50/50">
          <div className="bg-white p-5 rounded-2xl mb-6 text-sm text-slate-600 border border-slate-200 shadow-sm">
            <h3 className="font-bold text-slate-800 mb-2 flex items-center"><Activity className="h-4 w-4 mr-2 text-indigo-500"/> Envanter Hakkında</h3>
            <p className="leading-relaxed">{test.description}</p>
            {test.reference && (
              <p className="text-[11px] text-slate-400 italic mt-3 pt-3 border-t border-slate-100">
                <span className="font-bold">Referans:</span> {test.reference}
              </p>
            )}
          </div>

          <h3 className="font-black text-slate-800 text-lg mb-4 flex items-center">
            Maddeler / Sorular <span className="ml-3 bg-slate-200 text-slate-600 text-xs px-2 py-0.5 rounded-full">{test.questions?.length || 0} Madde</span>
          </h3>
          
          <div className="space-y-3">
            {test.questions?.map((q, idx) => {
              const questionText = typeof q === 'string' ? q : (q.text || q.label || q.question || "Soru metni bulunamadı");
              const options = q.options || test.options || [];

              return (
                <div key={idx} className="p-4 md:p-5 bg-white border border-slate-200 rounded-2xl shadow-sm hover:border-indigo-200 transition-colors">
                  <p className="font-bold text-slate-700 text-sm mb-3">
                    <span className="text-indigo-500 mr-1">{idx + 1}.</span> {questionText}
                  </p>
                  {options.length > 0 ? (
                    <div className="flex flex-wrap gap-2">
                      {options.map((opt, i) => {
                        const optLabel = typeof opt === 'string' ? opt : (opt.label || opt.text || opt);
                        return <span key={i} className="px-3 py-1.5 bg-slate-50 border border-slate-100 rounded-lg text-xs font-medium text-slate-600">{optLabel}</span>;
                      })}
                    </div>
                  ) : (
                    <span className="px-3 py-1.5 bg-slate-50 border border-slate-100 rounded-lg text-xs font-medium text-slate-400 italic">(Açık Uçlu / Metin Girişi)</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const QrModal = ({ test, onClose, user }) => { 
  // SİHİRLİ LİNK: Uzman kodu (ref) linkin içine gizlice gömülüyor
  // Bu link artık akıllı giriş ekranına (ParticipantLogin) yönlenecek
  const testLink = `${window.location.origin}/?test=${test.id}&ref=${user?.refCode || ''}&uid=${user?.uid || ''}`;
  
// --- DİNAMİK YÖNERGE MOTORU (GÜNCELLENDİ) ---
  const getDynamicIntro = (test) => {
    // Hitap Evrenselleştirildi
    const hitap = "Değerli Katılımcı,";

    // Testin kimliğini analiz edelim
    const testIdLower = test.id.toLowerCase();
    const testNameLower = test.name.toLowerCase();
    
    const isVeli = testIdLower.includes('veli') || testNameLower.includes('veli');
    const isOgretmen = testIdLower.includes('ogretmen') || testNameLower.includes('öğretmen');
    const isRiba = testIdLower.includes('riba');
    const isYasam = testIdLower.includes('yasam');

    // Amac metnini testin türüne göre şekillendirme
    let amacMetni = "Bu çalışma, bireysel ve sosyal gelişiminizi desteklemek ile ihtiyaç duyduğunuz alanları belirlemek amacıyla Okul PDR Servisimiz tarafından hazırlanmıştır.";

    if (isRiba) {
      amacMetni = "Rehberlik İhtiyaç Belirleme Anketi (RİBA) kapsamında, okulumuzdaki PDR hizmetlerinin doğrudan sizin gerçek ihtiyaçlarınıza göre planlanabilmesi amacıyla bu form hazırlanmıştır.";
    } else if (isYasam) {
      amacMetni = "Bu envanter, okul yaşamındaki, ailenizdeki ve sosyal çevrenizdeki durumunuzu daha kapsamlı anlayabilmemiz; riskli durumları önleyip güçlü yönlerinizi destekleyebilmemiz amacıyla hazırlanmıştır.";
    } else if (test.type === 'checklist') {
      amacMetni = "Bu kontrol listesi, belirli konulardaki mevcut durumunuzu gözden geçirmek ve size en uygun psikososyal desteği planlamak amacıyla hazırlanmıştır.";
    } else if (isVeli) {
      amacMetni = "Bu form, öğrencimizin gelişim sürecini daha etkin takip edebilmek ve okul-aile işbirliğini güçlendirmek amacıyla hazırlanmıştır.";
    } else if (isOgretmen) {
      amacMetni = "Bu form, öğrencilerimizin gelişim süreçlerini daha etkin takip edebilmek ve rehberlik hizmetlerini planlamak amacıyla profesyonel gözlemlerinize başvurmak için hazırlanmıştır.";
    }

    const testAciklamasi = test.description ? `<br><br><b>Testin İçeriği:</b> ${test.description}` : "";

    // 🎯 KİMLİK GİRİŞ METNİ DİNAMİKLEŞTİRİLDİ (Öğretmen, Veli, Öğrenci Ayrımı)
    let kimlikMetni = "<b>sınıf, şube ve okul/kurum bilgilerinizi</b>";
    if (isOgretmen) {
        kimlikMetni = "<b>branş (alan) bilgilerinizi</b>";
    } else if (isVeli) {
        kimlikMetni = "<b>öğrenciye ait sınıf, şube ve okul/kurum bilgilerinizi</b>";
    }

    return `
      <p style="font-weight: 800; font-size: 16px; margin-top: 0; margin-bottom: 8px; color: #1e293b;">${hitap}</p>
      <p style="color: #334155; margin-bottom: 8px;">${amacMetni}${testAciklamasi}</p>
      <p style="color: #334155; margin-bottom: 8px;">Maddeleri dikkatlice okumanız ve durumunuzu en iyi yansıtan seçenekleri samimiyetle işaretlemeniz, uygulamanın güvenirliği açısından büyük önem taşımaktadır. Elde edilen tüm veriler gizlilik ilkesine katı bir şekilde bağlı kalınarak yalnızca PDR Servisi uzmanları tarafından değerlendirilecektir.</p>
      <p style="font-weight: 600; color: #1e293b; margin-bottom: 0;">Katılımınız için teşekkür ederiz.</p>
      
      <hr style="border: none; border-top: 2px dashed #cbd5e1; margin: 15px 0;">
      
      <ul style="margin: 0; padding-left: 20px; color: #475569; font-size: 13px; line-height: 1.5;">
          <li style="margin-bottom: 4px;">Uygulamaya başlamadan önce ${kimlikMetni} eksiksiz giriniz.</li>
          <li style="margin-bottom: 4px;">Her bir maddeyi dikkatle değerlendirerek size en uygun seçeneği işaretleyiniz.</li>
          <li>Tüm maddeleri yanıtladıktan sonra <b>"Tamamla"</b> butonuna tıklayarak işlemi sonlandırınız.</li>
      </ul>
    `;
  };
// --------------------------------------------------------

  const handlePrintQr = () => {
    // 1. Ekrandaki QR Kodunu resim olarak al
    const canvas = document.querySelector('canvas');
    if (!canvas) return alert("QR Kod yüklenemedi.");
    const imgUrl = canvas.toDataURL('image/png');

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    
    const doc = iframe.contentWindow.document;
    doc.open();

   // 3. Tasarımı duruma göre ayarla
    doc.write(`
        <html>
        <head>
            <title>${test.name}</title>
            <style>
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800;900&display=swap');
                body { 
                    font-family: 'Inter', sans-serif; 
                    margin: 0; padding: 20px;
                    color: #0f172a;
                }
                .page-layout {
                    max-width: 800px; margin: 0 auto; text-align: center;
                }
                .header {
                    font-size: 26px; font-weight: 900; margin-bottom: 20px; text-transform: uppercase; border-bottom: 3px solid #0f172a; padding-bottom: 15px;
                }
                .instruction-box {
                    text-align: left; font-size: 14px; line-height: 1.5; background-color: #f8fafc; padding: 20px; border-radius: 16px; border: 2px solid #e2e8f0; margin-bottom: 25px;
                }
                .qr-container {
                    border: 3px dashed #cbd5e1; padding: 15px; display: inline-block; border-radius: 20px; background: white;
                }
                .qr-img { width: 180px; display: block; }
                .footer { margin-top: 25px; font-size: 12px; color: #64748b; font-weight: 800; text-transform: uppercase; letter-spacing: 1px; }
                
                /* YAZDIRMA (PRINT) ÖZEL AYARLARI - İKİNCİ SAYFAYI ENGELLER */
                @media print {
                    @page { margin: 1cm; }
                    body { padding: 0; }
                    .page-layout { margin-top: 0; }
                }
            </style>
        </head>
        <body>
            <div class="page-layout">
                <div class="header">${test.name}</div>
                
                <div class="instruction-box">
                    ${getDynamicIntro(test)}
                </div>

                <p style="font-weight: 800; font-size: 16px; margin-bottom: 10px; color: #0f172a;">Formu Doldurmak İçin Okutunuz</p>
                <div class="qr-container">
                    <img src="${imgUrl}" class="qr-img" />
                </div>

                <div class="footer">Rehber360 • Okul PDR Servisi</div>
            </div>
        </body>
        </html>
    `);
    doc.close();
    
    iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 1000);
    };
  };
  return (
    <div className="fixed inset-0 bg-slate-900/90 backdrop-blur-sm flex items-center justify-center z-[60] p-4 no-print">
      <div className="bg-white rounded-3xl p-8 max-w-md w-full text-center relative shadow-2xl animate-in fade-in zoom-in-95 duration-200">
        
        <button onClick={onClose} className="absolute top-4 right-4 p-2 hover:bg-slate-100 rounded-full">
            <X className="h-6 w-6 text-slate-400"/>
        </button>

        <div className="mb-6">
          <h2 className="text-2xl font-black text-slate-800">{test.name}</h2>
          <p className="text-slate-500 mt-2 text-sm">Öğrenciler bu QR kodu okutarak veya linki tıklayarak <strong className="text-blue-600">doğrudan bu testi</strong> açabilirler.</p>
        </div>

        <div className="bg-white p-4 border-4 border-slate-900 rounded-2xl inline-block mb-6 shadow-xl">
          <QRCodeCanvas value={testLink} size={200} level={"H"} />
        </div>

        <div className="flex items-center gap-2 bg-slate-100 p-3 rounded-xl mb-6 border border-slate-200">
          <Link className="h-4 w-4 text-slate-400 shrink-0"/>
          <input readOnly value={testLink} className="bg-transparent text-xs font-mono text-slate-600 w-full focus:outline-none"/>
          <button onClick={() => {navigator.clipboard.writeText(testLink); alert("Link kopyalandı!");}} className="text-blue-600 text-xs font-bold hover:underline">Kopyala</button>
        </div>

        <button onClick={handlePrintQr} className="w-full py-3 bg-slate-900 text-white rounded-xl font-bold flex items-center justify-center hover:bg-black transition shadow-lg hover:shadow-xl">
            <Share2 className="h-4 w-4 mr-2"/> Yazdır / Paylaş
        </button>
      </div>
    </div>
  ); 
};

const TestsPage = ({ onSelectTest, user }) => { 
  const [showQr, setShowQr] = useState(null); 
  // 🎯 EKLENEN STATE:
  const [showPreview, setShowPreview] = useState(null);

  return (
    <>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 no-print">
        {AVAILABLE_TESTS.map(t => (
          <div key={t.id} className="bg-white p-6 rounded-3xl border border-slate-200 hover:border-indigo-500 hover:shadow-lg transition group flex flex-col">
            <span className="bg-indigo-50 text-indigo-600 px-2 py-1 rounded-md text-[10px] font-black uppercase mb-3 inline-block w-fit">
              {t.type === 'checklist' ? 'KONTROL LİSTESİ' : (t.type === 'open_ended' ? 'AÇIK UÇLU' : (t.type === 'mix' ? 'BİLGİ FORMU' : (t.id.includes('riba') ? 'RİBA' : 'ENVANTER')))}
            </span>
            <h3 className="text-lg font-bold text-slate-900">{t.name}</h3>
            <p className="text-slate-500 text-xs mt-2 line-clamp-2 mb-4">{t.description}</p>
            
            {t.reference && (
                <p className="text-[10px] text-slate-400 italic mb-4 border-t border-slate-100 pt-3 leading-relaxed">
                    {t.reference}
                </p>
            )}

            {/* 🎯 DEĞİŞEN KISIM: İki buton yan yana konuldu */}
            <div className="mt-auto pt-4 border-t border-slate-100 flex justify-between items-center gap-2">
              <button 
                onClick={(e) => { e.stopPropagation(); setShowPreview(t); }} 
                className="flex-1 flex items-center justify-center text-xs font-bold text-slate-500 hover:text-indigo-600 bg-slate-50 hover:bg-indigo-50 px-3 py-2.5 rounded-xl border border-transparent hover:border-indigo-100 transition-colors"
              >
                <Eye className="h-4 w-4 mr-1.5"/> Önizle
              </button>
              
              <button 
                onClick={(e) => { e.stopPropagation(); setShowQr(t); }} 
                className="flex-1 flex items-center justify-center text-xs font-bold text-slate-500 hover:text-blue-600 bg-slate-50 hover:bg-blue-50 px-3 py-2.5 rounded-xl border border-transparent hover:border-blue-100 transition-colors"
              >
                <QrCode className="h-4 w-4 mr-1.5"/> Paylaş
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {showQr && <QrModal test={showQr} onClose={() => setShowQr(null)} user={user} />}
      {/* 🎯 EKLENEN KISIM: Modalı Çağırıyoruz */}
      {showPreview && <PreviewModal test={showPreview} onClose={() => setShowPreview(null)} />}
    </>
  ); 
};

export default TestsPage;